// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__YGItl","subtext":"styles_subtext__Bdjvc","link":"styles_link__3FQIg"};